import { object, string, number, array } from '@gogame/schemas';

import { PERIOD_START_DATE, OWNER_ID, CAMPAIGN_IDS } from '../constants';

export const ownerSchema = object({
  [OWNER_ID]: number().required('Owner is required'),
  [PERIOD_START_DATE]: string().required('Start date is required'),
  [CAMPAIGN_IDS]: array(number()),
});
